<template>
    <div class="flight_search_item_wrappper">
        <div class="flight_search_items multi_city">
            <div class="multi_city_flight_lists w-100">
                <div class="itineraries">

                    <div class="flight_multis_area_wrapper ">
                        <div class="flight_search_left">
                            <div class="flight_logo">
                                <img :src="require(`@/assets/img/icons/default_70.png`)" alt="img" />
                            </div>
                            <div class="flight_search_destination">
                                <p>
                                    <lv-skeleton :width="75" :height="15" primaryColor="var(--primary-color)"
                                        secondaryColor="var(--secondary-color)" />
                                </p>
                                <h3>
                                    <lv-skeleton :width="100" :height="15" primaryColor="var(--primary-color)"
                                        secondaryColor="var(--secondary-color)" />
                                </h3>
                                <h6>
                                    <lv-skeleton :width="150" :height="15" primaryColor="var(--primary-color)"
                                        secondaryColor="var(--secondary-color)" />
                                </h6>
                            </div>
                        </div>
                        <div class="flight_right_arrow">
                            <img :src="require(`@/assets/img/icons/right_arrow.png`)" alt="img" />
                            <h6>
                                <lv-skeleton :width="100" :height="15" primaryColor="var(--primary-color)"
                                    secondaryColor="var(--secondary-color)" />
                            </h6>
                            <p class="mt-2">
                                <lv-skeleton :width="100" :height="15" primaryColor="var(--primary-color)"
                                    secondaryColor="var(--secondary-color)" />
                            </p>
                        </div>
                        <div class="flight_search_middel">
                            <div class="flight_search_destination">
                                <p>
                                    <lv-skeleton :width="75" :height="15" primaryColor="var(--primary-color)"
                                        secondaryColor="var(--secondary-color)" />
                                </p>
                                <h3>
                                    <lv-skeleton :width="100" :height="15" primaryColor="var(--primary-color)"
                                        secondaryColor="var(--secondary-color)" />
                                </h3>
                                <h6>
                                    <lv-skeleton :width="150" :height="15" primaryColor="var(--primary-color)"
                                        secondaryColor="var(--secondary-color)" />
                                </h6>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="itineraries">

                    <div class="flight_multis_area_wrapper ">
                        <div class="flight_search_left">
                            <div class="flight_logo">
                                <img :src="require(`@/assets/img/icons/default_70.png`)" alt="img" />
                            </div>
                            <div class="flight_search_destination">
                                <p>
                                    <lv-skeleton :width="75" :height="15" primaryColor="var(--primary-color)"
                                        secondaryColor="var(--secondary-color)" />
                                </p>
                                <h3>
                                    <lv-skeleton :width="100" :height="15" primaryColor="var(--primary-color)"
                                        secondaryColor="var(--secondary-color)" />
                                </h3>
                                <h6>
                                    <lv-skeleton :width="150" :height="15" primaryColor="var(--primary-color)"
                                        secondaryColor="var(--secondary-color)" />
                                </h6>
                            </div>
                        </div>
                        <div class="flight_right_arrow">
                            <img :src="require(`@/assets/img/icons/right_arrow.png`)" alt="img" />
                            <h6>
                                <lv-skeleton :width="100" :height="15" primaryColor="var(--primary-color)"
                                    secondaryColor="var(--secondary-color)" />
                            </h6>
                            <p class="mt-2">
                                <lv-skeleton :width="100" :height="15" primaryColor="var(--primary-color)"
                                    secondaryColor="var(--secondary-color)" />
                            </p>
                        </div>
                        <div class="flight_search_middel">
                            <div class="flight_search_destination">
                                <p>
                                    <lv-skeleton :width="75" :height="15" primaryColor="var(--primary-color)"
                                        secondaryColor="var(--secondary-color)" />
                                </p>
                                <h3>
                                    <lv-skeleton :width="100" :height="15" primaryColor="var(--primary-color)"
                                        secondaryColor="var(--secondary-color)" />
                                </h3>
                                <h6>
                                    <lv-skeleton :width="150" :height="15" primaryColor="var(--primary-color)"
                                        secondaryColor="var(--secondary-color)" />
                                </h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flight_search_right">
                <h2>
                    <lv-skeleton :width="125" :height="15" primaryColor="var(--primary-color)"
                        secondaryColor="var(--secondary-color)" />
                </h2>
                <lv-skeleton :width="125" :height="15" primaryColor="var(--primary-color)"
                    secondaryColor="var(--secondary-color)" />
                <h6>
                    <lv-skeleton :width="125" :height="15" primaryColor="var(--primary-color)"
                        secondaryColor="var(--secondary-color)" />
                </h6>
            </div>
        </div>
    </div>
</template>
<script>
import LvSkeleton from 'lightvue/skeleton';
export default {
    name: "FlightMulitSkeletonItem",
    components: {
        LvSkeleton,
    },
};
</script>